export default __webpack_public_path__ + "static/media/motorway.8d499078.svg";